import React from 'react'
import { AutoSizer, List } from 'react-virtualized'

import { AVAILABLE, OCCUPIED } from '../constants/status'
import SortableHeader from '../components/SortableHeader'
import Icon from '../components/Icon'
import SubscriberDetailPane from '../components/SubscriberDetailPane'

const Subscriber = ({ style, subscriber, user, redirect, open, onClick }) => (
    <div {...{ style }} className={`subscriber ${subscriber.status.toLowerCase()}`}>
        <div className="main-row" onClick={onClick}>
            <div className="arrow">
                {open ? <Icon icon="triangle-bottom" className="open" /> : <Icon icon="triangle-right" className="closed" />}
            </div>
            <div className="status">{subscriber.status}</div>
            <div className="unit">{subscriber.unit}</div>
            <div className="username">{subscriber.username}</div>
            <div className="name">{subscriber.name}</div>
            <div className="site">{subscriber.site_name}</div>
            <div className="actions">
                {subscriber.url &&
                    <button className="webgui" onClick={e => { e.stopPropagation(); window.open(subscriber.url); }}><Icon icon="dashboard" title="Web-GUI" /></button>
                }
                <button className="history" onClick={() => redirect(`/history/${subscriber.username}`)}><Icon icon="list" title="Call-History" /></button>
                {user.isUnitAdmin(subscriber.unit_id) &&
                    <button className="edit" onClick={() => redirect(`/edit/${subscriber.username}`)}><Icon icon="edit" title="Edit" /></button>
                }
                {subscriber.status == AVAILABLE && user.isInUnit(subscriber.unit_id) &&
                    <button className="connect" onClick={() => redirect(`/connect/${subscriber.username}`)}><Icon icon="earphone" title="Initiate Call" /></button>
                }
            </div>
        </div>
        {subscriber.activeCall && subscriber.activeCall.destination &&
            <div className="call-info">in call with: <strong>{subscriber.activeCall.destination.name} ({subscriber.activeCall.destination.username})</strong> since {subscriber.activeCall.start_time}</div>
        }
        {open &&
            <SubscriberDetailPane className="detail-pane" subscriber={subscriber} user={user} />
        }
    </div>
)

export default class SubscriberList extends React.Component {
    constructor() {
        super()
        this.state = {
            selected: []
        }
    }
    componentDidUpdate(prevProps) {
        if(this.props.subscribers !== prevProps.subscribers) {
            this.list.recomputeRowHeights()
        }
    }
    onSubscriberClick(e, subscriber, index) {
        e.preventDefault()
        e.stopPropagation()
        this.setState({
            selected: this.state.selected.indexOf(subscriber.username) >= 0 ?
                [...this.state.selected.filter(i => i !== subscriber.username)] :
                [...this.state.selected, subscriber.username]
        }, () => {
            this.list.recomputeRowHeights(index)
        })
    }
    renderSubscriber({ index, key, style, parent }) {
        const { subscribers, user, redirect } = this.props
        const subscriber = subscribers[index]
        return <Subscriber {...{ key, style, subscriber, user, redirect }}
            open={this.state.selected.indexOf(subscriber.username) >= 0}
            onClick={e => this.onSubscriberClick(e, subscriber, index)} />
    }
    getRowHeight({ index }) {
        const { subscribers, user, redirect } = this.props
        const subscriber = subscribers[index]
        let rowHeight = 36
        if (this.state.selected.indexOf(subscriber.username) >= 0) rowHeight += 165
        if (subscriber.status === OCCUPIED) rowHeight += 25
        return rowHeight
    }
    render() {
        const { subscribers, sortOrder, onSort } = this.props
        return (
            <div className="subscriber-list">
                <div className="header">
                    <div className="status"><SortableHeader property="status" title="Status" sortInfo={sortOrder} onSort={onSort} /></div>
                    <div className="unit"><SortableHeader property="unit" title="Unit" sortInfo={sortOrder} onSort={onSort} /></div>
                    <div className="username"><SortableHeader property="username" title="Username" sortInfo={sortOrder} onSort={onSort} /></div>
                    <div className="name"><SortableHeader property="name" title="Name" sortInfo={sortOrder} onSort={onSort} /></div>
                    <div className="site"><SortableHeader property="site" title="Site" sortInfo={sortOrder} onSort={onSort} /></div>
                    <div className="actions">&nbsp;</div>
                </div>
                <div className="subscribers">
                    <AutoSizer>
                        {({ width, height }) => (
                            <List {...{ width, height }}
                                ref={e => this.list = e}
                                rowCount={subscribers.length}
                                rowRenderer={this.renderSubscriber.bind(this)}
                                rowHeight={this.getRowHeight.bind(this)} />
                        )}
                    </AutoSizer>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/SubscriberList.jsx